<template>
    <main class="bg-white py-10">
      <div class="container mx-auto px-4 pb-10">
        <!-- Title -->
        <h2 class="text-center text-3xl mb-8 font-bold text-yellow mt-8">Our Team</h2>
  
        <!-- Top Manager (ARC. Dr. Barka Mshelia) -->
        <div class="flex justify-center mb-10">
          <div class="w-72 text-center">
            <div class="bg-white shadow-lg rounded-lg overflow-hidden">
              <img
                class="w-full h-96 object-cover"
                src="../assets/images/barkaimagee.png"
                alt="ARC. Dr. Barka Umaru Mshelia"
              />
            </div>
            <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">ARC. Dr. Barka Umaru Mshelia</h4>
            <p class="text-gray-600">GMD/CEO</p>
          </div>
        </div>
  
        <!-- Other Team Members (Grid Layout) -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          <div v-for="(member, index) in team" :key="index" class="text-center">
            <div class="bg-white shadow-lg rounded-lg overflow-hidden">
              <img
                class="w-full h-[30vw] object-cover"
                :src="member.image"
                :alt="member.name"
              />
            </div>
            <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">{{ member.name }}</h4>
            <p class="text-gray-600">{{ member.position }}</p>
          </div>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  export default {
    data() {
      return {
        team: [
          {
            name: "Angela Kelechukwu",
            position: "AGM Growth and Strategy",
            image: require('../assets/images/mrs-angela.png'),
          },
          {
            name: "Amos Yunusa",
            position: "AGM Operations",
            image: require('../assets/images/mr Amos.png'),
          },
          {
            name: "Favour Ibrahim",
            position: "MD Lagos",
            image: require('../assets/images/favour.jpg'),
          },
          {
            name: "Jemima Buoro",
            position: "MD Kano",
            image: require('../assets/images/JEMIMA.png'),
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .board-style{
    font-family: Caveat;
  }
  </style>